import React from "react";
import QueueAnim from "rc-queue-anim";
import Bg01 from "@/assets/images/product/plan/bg01.jpg";
import Bg02 from "@/assets/images/product/plan/bg02.jpg";
import Bg03 from "@/assets/images/product/plan/bg03.jpg";
import Bg04 from "@/assets/images/product/plan/bg04.jpg";
import Bg05 from "@/assets/images/product/plan/bg05.jpg";
import Bg06 from "@/assets/images/product/plan/bg06.jpg";
import Bg07 from "@/assets/images/product/plan/bg07.jpg";
import Bg08 from "@/assets/images/product/plan/bg08.jpg";
import Bg09 from "@/assets/images/product/plan/bg09.jpg";
import Bg10 from "@/assets/images/product/plan/bg10.jpg";
import OverPack from "rc-scroll-anim/lib/ScrollOverPack";

const Plan: React.FC = () => {
  return (
    <div className='warp-plan header-top'>
      <div className='home-page'>
        <OverPack playScale={0.3}>
          <QueueAnim
            key="text"
            type="bottom"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            style={{minHeight: '600px'}}
          >
            <img src={Bg01} alt="" width='1200px' key='img' />
          </QueueAnim>
        </OverPack>
        <OverPack playScale={0.3}>
          <QueueAnim
            key="text"
            type="bottom"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            style={{minHeight: '600px', marginTop: '6px'}}
          >
            <img src={Bg02} alt="" width='1200px' key='img' />
          </QueueAnim>
        </OverPack>
        <OverPack playScale={0.3}>
          <QueueAnim
            key="text"
            type="bottom"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            style={{minHeight: '600px', marginTop: '6px'}}
          >
            <img src={Bg03} alt="" width='1200px' key='img' />
          </QueueAnim>
        </OverPack>
        <OverPack playScale={0.3}>
          <QueueAnim
            key="text"
            type="bottom"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            style={{minHeight: '600px', marginTop: '6px'}}
          >
            <img src={Bg04} alt="" width='1200px' key='img' />
          </QueueAnim>
        </OverPack>
        <OverPack playScale={0.3}>
          <QueueAnim
            key="text"
            type="bottom"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            style={{minHeight: '600px', marginTop: '6px'}}
          >
            <img src={Bg05} alt="" width='1200px' key='img' />
          </QueueAnim>
        </OverPack>
        <OverPack playScale={0.3}>
          <QueueAnim
            key="text"
            type="bottom"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            style={{minHeight: '600px', marginTop: '6px'}}
          >
            <img src={Bg06} alt="" width='1200px' key='img' />
          </QueueAnim>
        </OverPack>
        <OverPack playScale={0.3}>
          <QueueAnim
            key="text"
            type="bottom"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            style={{minHeight: '600px', marginTop: '6px'}}
          >
            <img src={Bg07} alt="" width='1200px' key='img' />
          </QueueAnim>
        </OverPack>
        <OverPack playScale={0.3}>
          <QueueAnim
            key="text"
            type="bottom"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            style={{minHeight: '600px', marginTop: '6px'}}
          >
            <img src={Bg08} alt="" width='1200px' key='img' />
          </QueueAnim>
        </OverPack>
        <OverPack playScale={0.3}>
          <QueueAnim
            key="text"
            type="bottom"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            style={{minHeight: '600px', marginTop: '6px'}}
          >
            <img src={Bg09} alt="" width='1200px' key='img' />
          </QueueAnim>
        </OverPack>
        <OverPack playScale={0.3}>
          <QueueAnim
            key="text"
            type="bottom"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            style={{minHeight: '600px', marginTop: '6px'}}
          >
            <img src={Bg10} alt="" width='1200px' key='img' />
          </QueueAnim>
        </OverPack>
      </div>

    </div>
  )
}

export default Plan